import React, { useEffect, useMemo, useRef, useState } from "react";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Header from "../../sharedScreens/Header";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { FormikValues, useFormik } from "formik";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import dayjs from "dayjs";

import {
  CorporateManagementSchema,
  ManageBookingSchema,
} from "../../validations/Schema";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MuiUploader from "../../components/basicComponent/MuiUploader";

import MuiCheckbox from "../../components/basicComponent/MuiCheckbox";
import Permissions from "./Permissions";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import { branchList, titleList } from "../../constants/constant";
import { UserRegisterService } from "../../services/UserRegisterService";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import { useLocation, useNavigate } from "react-router-dom";
import { deepOmit } from "../../constants/helper";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import { CorporateFormValues } from "@/constants/types";
import PhoneInput from "react-phone-input-2";
type List = {
  label: string;
  value: string;
};
const CorporateManagement = () => {
  const location = useLocation();
  const data = location.state?.data?.[0] || null; // Check if user data exists
  const corporateId = data?.id;
  const isEditable = location?.state?.isEdit;
  const [clearPermissions, setClearPermissions] = useState<boolean>();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [countryList, setCountryList] = useState<List[]>([]);
  const [stateList, setStateList] = useState<List[]>([]);
  const [cityList, setCityList] = useState<List[]>([]);
  const [categoriesList, setCategoriesList] = useState<
    Array<{ label: string; value: string; id: number }>
  >([]);
  const [hotelCategoriesList, setHotelCategoriesList] = useState<
    Array<{ label: string; value: string; id: number }>
  >([]);
  const [value, setValue] = React.useState("1");
  const [view, SetView] = useState<Boolean>(false);
  const [selectedCurrency, setSelectedCurrency] = useState<string>("");
  const [currencyCodeList, setCurrencyCodeList] = useState<
    Array<{
      id: string;
      name: string;
      code: string;
      label: string;
      value: string;
    }>
  >([]);
  const [rows, setRows] = useState<any[]>([{}]);
  const [cityName, setCityName] = useState<string>("");
  const { showSuccess, showError } = useSweetAlert();
  // Refs for form fields to enable scrolling and focusing
  const fieldRefs = useRef<{ [key: string]: HTMLElement | null }>({});

  // Function to register field refs
  const setFieldRef = (fieldName: string) => (ref: HTMLElement | null) => {
    fieldRefs.current[fieldName] = ref;
  };

  // Function to scroll to the first error field and focus on it
  const scrollToFirstError = (errors: Record<string, any>) => {
    const fieldOrder = [
      "business_name",
      "type",
      "branch",
      "title",
      "firstName",
      "lastName",
      "address",
      "admin_email",
      "mobile_no",
      "postal_code",
      "currency",
      "countryId",
      "statesId",
      "cityName",
      "date",
      "trade_license_doc",
      "emirates_id_doc",
      "corporateLogo",
      "airline_commission",
      "payment_mode",
    ];

    const firstErrorField = fieldOrder.find((field) => errors[field]);

    if (firstErrorField) {
      const element = fieldRefs.current[firstErrorField];

      if (element) {
        // Scroll to the element smoothly
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });

        // Focus on the input element after a short delay
        setTimeout(() => {
          const inputElement = element.querySelector(
            "input, select, textarea"
          ) as HTMLElement | null;

          if (inputElement) {
            inputElement.focus();
          } else {
            element.focus();
          }
        }, 300);
      }
    }
  };

  const handleonChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const typeList = [
    { label: "Default", value: "Default" },
    {
      label: "B2E- Travel Co-Ordinator",
      value: "B2E- Travel Co-Ordinator",
    },
    {
      label: "CBT-Employee Booking",
      value: "CBT-Employee Booking",
    },
  ];
  const navigate = useNavigate();
  const initialValues: CorporateFormValues = useMemo(
    () => ({
      business_name: data?.businessName ?? "",
      type: data?.type ?? "",
      branch: data?.branch ?? "",
      title: data?.title ?? "",
      firstName: data?.user?.firstName ?? "",
      lastName: data?.user?.lastName ?? "",
      address: data?.address ?? "",
      mobile_no: data?.mobileNo ?? "",
      email_id_alternate: data?.emailIdAlternate ?? "",
      phone_number: data?.phoneNumber ?? "",
      postal_code: data?.postalCode ?? "",
      countryId: data?.country?.name ?? "",
      country: data?.country?.countryIdentifier ?? "",
      state: data?.state?.stateIdentifier ?? "",
      statesId: data?.state?.name ?? "",
      city: data?.city?.cityIdentifier ?? "",
      cityName: data?.city?.name ?? "",
      currency: data?.currency ?? "",
      date: data?.dateJoined ? new Date(data?.dateJoined) : undefined,
      trade_license_doc: data?.tradeLicenseDoc ?? "",
      emirates_id_doc: data?.emiratesIdDoc ?? "",
      admin_email: data?.user?.email ?? "",
      admin_password: "User@123",
      admin_confirm_password: "User@123",
      admin_feature_ids:
        data?.user?.featurePermissions?.map((i: any) => i?.feature) ?? [],
      airline_commission_category: data?.airlineCommissionCategory ?? "",
      airline_commission: data?.airlineCommissionCategoryName ?? "",
      payment_mode: data?.paymentMode ?? "",
      corporateLogo: data?.corporateLogo ?? "",
      istopUpSelected:
        data?.paymentMode === "both" || data?.paymentMode === "topup",
      isPGSelected:
        data?.paymentMode === "both" || data?.paymentMode === "gateway",
      selectedCurrency: Array.isArray(currencyCodeList)
        ? currencyCodeList?.find((i: any) => i?.id === data?.currency)?.name ??
          ""
        : "5", //5 is  id for AED
    }),
    [data]
  );

  const formik = useFormik<CorporateFormValues>({
    initialValues,
    validationSchema: CorporateManagementSchema,
    enableReinitialize: true,
    onSubmit(values, formikHelpers) {
      console.log("Form submitted with values:", values);
      createCoorporate();
    },
  });

  const [activeTab, setActiveTab] = useState("home");

  const handleFileUpload = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("trade_license_doc", "File upload failed.");
    } else {
      formik.setFieldValue("trade_license_doc", uploadedFileUrl);
      formik.setFieldError("trade_license_doc", "");
    }
  };
  const handleEmirateDoc = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("emirates_id_doc", "File upload failed.");
    } else {
      formik.setFieldValue("emirates_id_doc", uploadedFileUrl);
      formik.setFieldError("emirates_id_doc", "");
    }
  };
  const handleCorporateDoc = (uploadedFileUrl: string | null) => {
    if (!uploadedFileUrl) {
      formik.setFieldError("corporateLogo", "File upload failed.");
    } else {
      formik.setFieldValue("corporateLogo", uploadedFileUrl);
      formik.setFieldError("corporateLogo", "");
    }
  };
  useEffect(() => {
    getCountry();
    getFlightCategories();
    getHotelCategories();
  }, []);
  const getCountry = async () => {
    const response = await UtilService.getCountry();
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map(
        (i: { countryName: any; countryId: any }) => ({
          id: i?.countryId,
          label: i?.countryName,
          value: i?.countryName,
        })
      );
      setCountryList(arr);
    }
  };

  useEffect(() => {
    if (!!formik.values.country) {
      getState(formik.values.country);
    }
    if (!!formik.values.state) {
      getCity(formik.values.state);
    }
  }, []);

  const getState = async (countryId: string) => {
    const id = !!countryId ? countryId : formik.values.country;
    const response = await UtilService.getState(id);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map(
        (i: { statesName: any; statesId: any }) => ({
          id: i?.statesId,
          label: i?.statesName,
          value: i?.statesName,
        })
      );

      setStateList(arr);
    }
  };

  const getCity = async (stateId: string) => {
    const id = !!stateId ? stateId : formik.values.state;
    const response = await UtilService.getCity(id);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const arr = response?.data?.map((i: { cityName: any; cityId: any }) => ({
        id: i?.cityId,
        label: i?.cityName,
        value: i?.cityName,
      }));
      setCityList(arr);
    }
  };

  const getFlightCategories = async () => {
    try {
      const res = await UtilService.categoriesList();
      if (!!res) {
        const data =
          res.data?.map((i: { name: string; id: number }) => ({
            label: i?.name,
            value: i?.name,
            id: i?.id,
          })) || [];

        setCategoriesList(data);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const getHotelCategories = async () => {
    try {
      const res = await UtilService.hotelCategoriesList();
      if (!!res) {
        const data =
          res.data?.map((i: { name: string; id: number }) => ({
            label: i?.name,
            value: i?.name,
            id: i?.id,
          })) || [];

        setHotelCategoriesList(data);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  useEffect(() => {
    const { istopUpSelected, isPGSelected } = formik.values;

    if (istopUpSelected && isPGSelected) {
      formik.setFieldValue("payment_mode", "both");
    } else if (istopUpSelected) {
      formik.setFieldValue("payment_mode", "topup");
    } else if (isPGSelected) {
      formik.setFieldValue("payment_mode", "gateway");
    } else {
      formik.setFieldValue("payment_mode", ""); // Or handle the "none selected" case
    }
  }, [formik.values.istopUpSelected, formik.values.isPGSelected]);

  const createCoorporate = async () => {
    try {
      const payload = {
        ...formik.values,
        admin_password: "User@123",
        admin_confirm_password: "User@123",
      };
      const response = await UserRegisterService.saveCorporateManagement(
        payload
      );
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        showSuccess("Success!", "Corporate has been created successfully.");
        formik.resetForm();
        navigate("/corporatelist");
      } else {
        showError(
          "Oops...",
          response.statusRemark ??
            "Something went wrong while creating corporate!"
        );
      }
    } catch (error) {}
  };

  const getPermissionsId = (id: string[]) => {
    formik.setFieldValue("admin_feature_ids", id);
  };

  useEffect(() => {
    getCurrencyCodeList();
  }, []);

  const getCurrencyCodeList = async () => {
    try {
      const res = await UtilService.getCurrency();
      const data =
        res?.data?.map((i: { name: string; id: string; code: string }) => ({
          label: i?.name + " , " + i?.code,
          value: i?.name + " , " + i?.code,
          id: i?.id,
        })) || [];

      setCurrencyCodeList(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const editCorporate = async () => {
    const values = deepOmit(formik.values, [
      "admin_email",
      "isPGSelected",
      "istopUpSelected",
    ]);
    const payload = {
      ...values,
    };
    try {
      const response = await UtilService.editCorporate(payload, corporateId);
      if (!!response?.data) {
        showSuccess("Success!", "Corporate has been updated successfully.");
        navigate("/corporatelist");
      }
    } catch (error) {
      console.log("error while edit corporate", error);
    }
  };

  // Enhanced submit handler with scroll to error functionality
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Trigger form validation
    const errors = await formik.validateForm();

    // Mark all required fields as touched
    formik.setTouched({
      business_name: true,
      type: true,
      branch: true,
      title: true,
      firstName: true,
      lastName: true,
      address: true,
      admin_email: true,
      mobile_no: true,
      postal_code: true,
      currency: true,
      countryId: true,
      statesId: true,
      cityName: true,
      date: true,
      trade_license_doc: true,
      emirates_id_doc: true,
      corporateLogo: true,
      airline_commission: true,
      istopUpSelected: true,
      selectedCurrency: true,
      payment_mode: true,
    });

    if (Object.keys(errors).length > 0) {
      // If there are errors, scroll to the first error field
      scrollToFirstError(errors);
      return;
    }

    // If no errors, proceed with form submission
    if (isEditable) {
      editCorporate();
    } else {
      formik.handleSubmit();
    }
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">
                {isEditable ? "Update Corporate" : "Create Corporate"}
              </h3>
            </div>
            <div className="row">
              <div className="col-md-12 ">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <div className="card card-custom ">
                      <TabList
                        onChange={handleonChange}
                        aria-label="lab API tabs example"
                        variant="scrollable"
                        scrollButtons="auto"
                      >
                        <Tab
                          label="Corporate "
                          value="1"
                          className={`tab ${
                            activeTab === "home" ? "active" : ""
                          }`}
                        />
                        {/* <Tab
                          label="Corporate view"
                          value="2"
                          className={`tab ${
                            activeTab === "about" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("about")}
                        /> */}
                      </TabList>
                      <div
                        className="tab-content"
                        ref={setFieldRef("business_name")}
                      >
                        <TabPanel value="1">
                          <div className="row mt-3">
                            <div className="col-md-4 mb-4">
                              <MuiInput
                                placeholder="Business Name"
                                label={"Business Name"}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.business_name &&
                                  Boolean(formik.errors.business_name)
                                }
                                errorText={
                                  formik.touched.business_name &&
                                  formik.errors.business_name
                                    ? formik.errors.business_name?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("business_name", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("business_name", true)
                                }
                                value={formik.values.business_name}
                              />
                            </div>

                            {/* <div className="col-md-4 mb-4">
                              <MuiInput
                                placeholder="Corporate Name"
                                label={"Corporate Name "}
                                isInvalid={
                                  formik.touched.corporate_id &&
                                  Boolean(formik.errors.corporate_id)
                                }
                                isRequired={true}
                                errorText={
                                  formik.touched.corporate_id &&
                                  formik.errors.corporate_id
                                    ? formik.errors.corporate_id?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("corporate_id", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("corporate_id", true)
                                }
                                value={formik.values.corporate_id}
                              />
                            </div> */}

                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                placeholder={"Type"}
                                label="Type"
                                options={typeList}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("type", value);
                                  formik.setFieldValue("typeCode", data.code);
                                }}
                                ref={setFieldRef("type")}
                                isRequired={true}
                                value={formik.values.type}
                                errorText={
                                  formik.touched.type && formik.errors.type
                                    ? formik.errors.type?.toString()
                                    : ""
                                }
                                isInvalid={
                                  formik.touched.type &&
                                  Boolean(formik.errors.type)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("type", true)
                                }
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                placeholder={"Branch "}
                                label="Branch "
                                options={branchList}
                                ref={setFieldRef("branch")}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("branch", value);
                                  formik.setFieldValue("branchCode", data.code);
                                }}
                                isRequired={true}
                                value={formik.values.branch}
                                errorText={
                                  formik.touched.branch && formik.errors.branch
                                    ? formik.errors.branch?.toString()
                                    : ""
                                }
                                isInvalid={
                                  formik.touched.branch &&
                                  Boolean(formik.errors.branch)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("branch", true)
                                }
                              />
                            </div>
                            <div className="col-md-2 mb-4">
                              <MuiSearchSelect
                                label="Title "
                                placeholder={"Title "}
                                options={titleList}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("title", value);
                                  formik.setFieldValue("titleCode", data.code);
                                }}
                                ref={setFieldRef("title")}
                                value={formik.values.title}
                                errorText={
                                  formik.touched.title && formik.errors.title
                                    ? formik.errors.title?.toString()
                                    : ""
                                }
                                isRequired={true}
                                isInvalid={
                                  formik.touched.title &&
                                  Boolean(formik.errors.title)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("title", true)
                                }
                              />
                            </div>
                            <div
                              className="col-md-3 mb-4"
                              ref={setFieldRef("firstName")}
                            >
                              <MuiInput
                                label={"First Name"}
                                placeholder="First Name"
                                isRequired={true}
                                isInvalid={
                                  formik.touched.firstName &&
                                  Boolean(formik.errors.firstName)
                                }
                                errorText={
                                  formik.touched.firstName &&
                                  formik.errors.firstName
                                    ? formik.errors.firstName?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("firstName", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("firstName", true)
                                }
                                value={formik.values.firstName}
                              />
                            </div>
                            <div
                              className="col-md-3 mb-4"
                              ref={setFieldRef("lastName")}
                            >
                              <MuiInput
                                label={"Last Name"}
                                placeholder="Last Name"
                                isRequired={true}
                                isInvalid={
                                  formik.touched.lastName &&
                                  Boolean(formik.errors.lastName)
                                }
                                errorText={
                                  formik.touched.lastName &&
                                  formik.errors.lastName
                                    ? formik.errors.lastName?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("lastName", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("lastName", true)
                                }
                                value={formik.values.lastName}
                              />
                            </div>

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("address")}
                            >
                              <MuiInput
                                label={"Address"}
                                placeholder="Address"
                                isInvalid={
                                  formik.touched.address &&
                                  Boolean(formik.errors.address)
                                }
                                isRequired={true}
                                errorText={
                                  formik.touched.address &&
                                  formik.errors.address
                                    ? formik.errors.address?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("address", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("address", true)
                                }
                                value={formik.values.address}
                              />
                            </div>

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("admin_email")}
                            >
                              <MuiInput
                                label={"Email Id (Primary)"}
                                placeholder="Email Id (Primary)"
                                isRequired={true}
                                isInvalid={
                                  formik.touched.admin_email &&
                                  Boolean(formik.errors.admin_email)
                                }
                                errorText={
                                  formik.touched.admin_email &&
                                  formik.errors.admin_email
                                    ? formik.errors.admin_email?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("admin_email", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("admin_email", true)
                                }
                                value={formik.values.admin_email}
                                disabled={!!data?.user?.email}
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiInput
                                label={"Email Id (Alternate)"}
                                placeholder="Alternate Email"
                                isInvalid={
                                  formik.touched.email_id_alternate &&
                                  Boolean(formik.errors.email_id_alternate)
                                }
                                errorText={
                                  formik.touched.email_id_alternate &&
                                  formik.errors.email_id_alternate
                                    ? formik.errors.email_id_alternate?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue(
                                    "email_id_alternate",
                                    value
                                  )
                                }
                                onBlur={() =>
                                  formik.setFieldTouched(
                                    "email_id_alternate",
                                    true
                                  )
                                }
                                value={formik.values.email_id_alternate}
                              />
                            </div>

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("mobile_no")}
                            >
                              {/* <MuiInput
                                label={"Mobile No."}
                                placeholder="Mobile No."
                                isRequired={true}
                                isInvalid={
                                  formik.touched.mobile_no &&
                                  Boolean(formik.errors.mobile_no)
                                }
                                errorText={
                                  formik.touched.mobile_no &&
                                  formik.errors.mobile_no
                                    ? formik.errors.mobile_no?.toString()
                                    : ""
                                }
                                ref={setFieldRef("mobile_no")}
                                onChange={(value) => {
                                  const digitsOnly = value
                                    .replace(/\D/g, "")
                                    .slice(0, 10);
                                  formik.setFieldValue("mobile_no", digitsOnly);
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("mobile_no", true)
                                }
                                value={formik.values.mobile_no}
                              /> */}
                              <div className="form-group">
                                <PhoneInput
                                  value={formik.values.mobile_no}
                                  placeholder="Enter mobile number"
                                  onChange={(value) => {
                                    const digitsOnly = value
                                      .replace(/\D/g, "")
                                      .slice(0, 15); // Adjust length as per need
                                    formik.setFieldValue(
                                      "mobile_no",
                                      digitsOnly
                                    );
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    borderColor:
                                      formik.touched.mobile_no &&
                                      formik.errors.mobile_no
                                        ? "#d32f2f"
                                        : "#ccc",
                                  }}
                                  preferredCountries={["ae", "in", "us"]}
                                  enableSearch
                                  inputProps={{
                                    name: "mobile",
                                    required: true,
                                    onBlur: () =>
                                      formik.setFieldTouched("mobile_no", true),
                                  }}
                                  isValid={(value: string) => {
                                    const mobileRegex = /^[0-9]{8,15}$/;
                                    const isValid = mobileRegex.test(
                                      value.replace(/^\+?\d{1,4}/, "")
                                    );
                                    return isValid || "";
                                  }}
                                />

                                {/* Manually show Formik error below the input */}
                                {formik.touched.mobile_no &&
                                  formik.errors.mobile_no && (
                                    <span className="phone-error-msg">
                                      {formik.errors.mobile_no}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("phone_number")}
                            >
                              <PhoneInput
                                value={formik.values.phone_number}
                                placeholder="Enter phone number"
                                onChange={(value) => {
                                  const digitsOnly = value
                                    .replace(/\D/g, "")
                                    .slice(0, 15); // Adjust length as per need
                                  formik.setFieldValue(
                                    "phone_number",
                                    digitsOnly
                                  );
                                }}
                                inputStyle={{
                                  width: "100%",
                                  borderColor:
                                    formik.touched.phone_number &&
                                    formik.errors.phone_number
                                      ? "#d32f2f"
                                      : "#ccc",
                                }}
                                preferredCountries={["ae", "in", "us"]}
                                enableSearch
                                inputProps={{
                                  name: "mobile",
                                  required: true,
                                  onBlur: () =>
                                    formik.setFieldTouched(
                                      "phone_number",
                                      true
                                    ),
                                }}
                                isValid={(value: string) => {
                                  const mobileRegex = /^[0-9]{8,15}$/;
                                  const isValid = mobileRegex.test(
                                    value.replace(/^\+?\d{1,4}/, "")
                                  );
                                  return isValid || "";
                                }}
                              />

                              {/* Manually show Formik error below the input */}
                              {formik.touched.phone_number &&
                                formik.errors.phone_number && (
                                  <span className="phone-error-msg">
                                    {formik.errors.phone_number}
                                  </span>
                                )}
                            </div>

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("postal_code")}
                            >
                              <MuiInput
                                label={"Postal Code"}
                                placeholder="Postal Code"
                                isInvalid={
                                  formik.touched.postal_code &&
                                  Boolean(formik.errors.postal_code)
                                }
                                errorText={
                                  formik.touched.postal_code &&
                                  formik.errors.postal_code
                                    ? formik.errors.postal_code?.toString()
                                    : ""
                                }
                                isRequired={true}
                                onChange={(value) => {
                                  // ✅ Only allow digits and max 6 characters
                                  const digitsOnly = value
                                    .replace(/\D/g, "")
                                    .slice(0, 10);
                                  formik.setFieldValue(
                                    "postal_code",
                                    digitsOnly
                                  );
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("postal_code", true)
                                }
                                value={formik.values.postal_code}
                                slotProps={{
                                  htmlInput: {
                                    maxLength: 10,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  },
                                }}
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                label="Currency"
                                placeholder="Currency"
                                options={currencyCodeList}
                                onChange={(val, id) => {
                                  formik.setFieldValue("currency", id);
                                  formik.setFieldValue("selectedCurrency", val);
                                }}
                                value={formik.values.selectedCurrency}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.selectedCurrency &&
                                  !!formik.errors.selectedCurrency
                                }
                                ref={setFieldRef("selectedCurrency")}
                                errorText={
                                  formik.touched.selectedCurrency &&
                                  formik.errors.selectedCurrency
                                    ? formik.errors.selectedCurrency?.toString()
                                    : ""
                                }
                                onBlur={() =>
                                  formik.setFieldTouched(
                                    "selectedCurrency",
                                    true
                                  )
                                }
                              />
                            </div>
                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("trade_license_doc")}
                            >
                              <MuiUploader
                                label={"Trade License"}
                                name={"trade_license_doc"}
                                isRequired={true}
                                values={formik.values.trade_license_doc}
                                errors={
                                  formik.touched.trade_license_doc &&
                                  formik.errors.trade_license_doc
                                    ? formik.errors.trade_license_doc?.toString()
                                    : ""
                                }
                                onFileUpload={handleFileUpload}
                              />
                            </div>
                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("emirates_id_doc")}
                            >
                              <MuiUploader
                                label={"Emirates ID"}
                                name={"emirates_id_doc"}
                                isRequired={true}
                                values={formik.values.emirates_id_doc}
                                errors={
                                  formik.touched.emirates_id_doc &&
                                  formik.errors.emirates_id_doc
                                    ? formik.errors.emirates_id_doc?.toString()
                                    : ""
                                }
                                onFileUpload={handleEmirateDoc}
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                label="Country "
                                placeholder={"Country "}
                                options={countryList}
                                isInvalid={
                                  formik.touched.countryId &&
                                  Boolean(formik.errors.countryId)
                                }
                                errorText={
                                  formik.touched.countryId &&
                                  formik.errors.countryId
                                    ? formik.errors.countryId?.toString()
                                    : ""
                                }
                                isRequired={true}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("country", id);
                                  formik.setFieldValue("countryId", value);
                                  !!id && getState(id);
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("countryId", true)
                                }
                                value={formik.values.countryId}
                                ref={setFieldRef("countryId")}
                              />
                            </div>
                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("date")}
                            >
                              <MuiDatePicker
                                label="Date of Joining"
                                value={
                                  formik.values.date
                                    ? dayjs(formik.values.date)
                                    : null
                                }
                                onChange={(date: string) => {
                                  formik.setFieldValue("date", date);
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("date", true)
                                } // Mark as touched
                                isError={
                                  formik.touched.date &&
                                  Boolean(formik.errors.date)
                                }
                                errorText={
                                  formik.touched.date
                                    ? (formik.errors.date as string) || ""
                                    : ""
                                }
                                isRequired={true}
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                label="State  "
                                placeholder={"State "}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.statesId &&
                                  Boolean(formik.errors.statesId)
                                }
                                errorText={
                                  formik.touched.statesId &&
                                  formik.errors.statesId
                                    ? formik.errors.statesId?.toString()
                                    : ""
                                }
                                options={stateList}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("state", id);
                                  formik.setFieldValue("statesId", value);
                                  getCity(id);
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("statesId", true)
                                }
                                value={formik.values.statesId}
                                ref={setFieldRef("statesId")}
                              />
                            </div>
                            <div className="col-md-4 mb-4">
                              <MuiSearchSelect
                                label="City  "
                                placeholder={"City  "}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.cityName &&
                                  Boolean(formik.errors.cityName)
                                }
                                errorText={
                                  formik.touched.cityName &&
                                  formik.errors.cityName
                                    ? formik.errors.cityName?.toString()
                                    : ""
                                }
                                options={cityList}
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("city", id);
                                  formik.setFieldValue("cityName", value);
                                }}
                                onBlur={() =>
                                  formik.setFieldTouched("cityName", true)
                                }
                                value={formik.values.cityName}
                                ref={setFieldRef("cityName")}
                              />
                            </div>
                            {/* <div className="col-md-4 mb-4">
                              <MuiInput
                                label={"Accounts Ref.ID"}
                                placeholder="Accounts Ref.ID"
                                isInvalid={
                                  formik.touched.accountsRefId &&
                                  Boolean(formik.errors.accountsRefId)
                                }
                                isRequired={true}
                                errorText={
                                  formik.touched.accountsRefId &&
                                  formik.errors.accountsRefId
                                    ? formik.errors.accountsRefId?.toString()
                                    : ""
                                }
                                onChange={(value) =>
                                  formik.setFieldValue("accountsRefId", value)
                                }
                                onBlur={() =>
                                  formik.setFieldTouched("accountsRefId", true)
                                }
                                value={formik.values.accountsRefId}
                              />
                            </div> */}

                            <div
                              className="col-md-4 mb-4"
                              ref={setFieldRef("corporateLogo")}
                            >
                              <MuiUploader
                                label={"Corporate Logo"}
                                name={"corporateLogo"}
                                isRequired={true}
                                values={formik.values.corporateLogo}
                                errors={
                                  formik.touched.corporateLogo &&
                                  formik.errors.corporateLogo
                                    ? formik.errors.corporateLogo?.toString()
                                    : ""
                                }
                                onFileUpload={handleCorporateDoc}
                              />
                            </div>
                            <div className="row">
                              <div className="col-md-6">
                                <div className="row">
                                  <h6
                                    style={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                      paddingBottom: "12px",
                                    }}
                                  >
                                    Payment mode
                                    <span style={{ color: "red" }}> *</span>
                                  </h6>
                                  <div className="col-xl-5 col-lg-4 col-md-6 mb-3">
                                    <MuiCheckbox
                                      name={"istopUpSelected"}
                                      checked={formik.values.istopUpSelected}
                                      onChange={() =>
                                        formik.setFieldValue(
                                          "istopUpSelected",
                                          !formik.values.istopUpSelected
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="istopUpSelected"
                                    >
                                      Top-Up Selected
                                    </label>
                                  </div>
                                  <div className="col-xl-7 col-lg-6 col-md-6 mb-3">
                                    <MuiCheckbox
                                      name={formik.values.isPGSelected?.toString()}
                                      onChange={() => {
                                        formik.setFieldValue(
                                          "isPGSelected",
                                          !formik.values.isPGSelected
                                        );
                                      }}
                                      checked={formik.values.isPGSelected}
                                    />
                                    <label htmlFor="">Payment Gateway</label>
                                  </div>

                                  {(formik.touched.istopUpSelected ||
                                    formik.touched.isPGSelected) &&
                                    (formik.errors.istopUpSelected ||
                                      formik.errors.isPGSelected) && (
                                      <div
                                        className="text-danger fs-12"
                                        style={{
                                          fontSize: "12px",
                                          color: "#d32f2f",
                                          paddingLeft: "12px",
                                          marginTop: "-8px",
                                        }}
                                      >
                                        {formik.errors.istopUpSelected ||
                                          formik.errors.isPGSelected}
                                      </div>
                                    )}
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="row">
                                  <h6
                                    style={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                      paddingBottom: "12px",
                                      textAlign: "center",
                                      paddingLeft: "100px",
                                    }}
                                  >
                                    Commission/Markup/Service Fee
                                  </h6>
                                  <div className="col-xl-4 col-lg-4 col-md-6 mb-3 "></div>
                                  <div
                                    className="col-xl-8 col-lg-4 col-md-6 mb-3 "
                                    ref={setFieldRef("airline_commission")}
                                  >
                                    <MuiSearchSelect
                                      label="Airline Category"
                                      placeholder={"Airline Category"}
                                      isInvalid={
                                        formik.touched.airline_commission &&
                                        Boolean(
                                          formik.errors.airline_commission
                                        )
                                      }
                                      errorText={
                                        formik.touched.airline_commission &&
                                        formik.errors.airline_commission
                                          ? formik.errors.airline_commission?.toString()
                                          : ""
                                      }
                                      options={categoriesList}
                                      onChange={(value, id, data) => {
                                        formik.setFieldValue(
                                          "airline_commission_category",
                                          id
                                        );
                                        formik.setFieldValue(
                                          "airline_commission",
                                          value
                                        );
                                      }}
                                      onBlur={() =>
                                        formik.setFieldTouched(
                                          "airline_commission",
                                          true
                                        )
                                      }
                                      value={formik.values.airline_commission}
                                      isRequired={true}
                                    />
                                  </div>
                                  {/* <div className="col-xl-6 col-lg-6 col-md-6 mb-3">
                                    <MuiSearchSelect
                                      label="Hotel Category"
                                      placeholder={"Hotel Category"}
                                      isInvalid={
                                        formik.touched.hotel_commission &&
                                        Boolean(formik.errors.hotel_commission)
                                      }
                                      errorText={
                                        formik.touched.hotel_commission &&
                                        formik.errors.hotel_commission
                                          ? formik.errors.hotel_commission
                                          : ""
                                      }
                                      options={hotelCategoriesList}
                                      onChange={(value, id, data) => {
                                        formik.setFieldValue(
                                          "hotel_commissio",
                                          value
                                        );
                                        formik.setFieldValue(
                                          "hotel_commission_category",
                                          id
                                        );
                                      }}
                                      onBlur={() =>
                                        formik.setFieldTouched(
                                          "hotel_commission_category",
                                          true
                                        )
                                      }
                                      value={formik.values.hotel_commission}
                                    />
                                  </div> */}
                                </div>
                              </div>
                            </div>
                            <Permissions
                              permissionId={getPermissionsId}
                              selectedPermissionId={
                                formik.values.admin_feature_ids
                              }
                              clearPermissions={clearPermissions}
                            />

                            <div className="user-button w-full">
                              <MuiButton
                                className="clear-btn"
                                label={isEditable ? "Back" : "Clear"}
                                onClick={
                                  isEditable
                                    ? () => navigate(-1)
                                    : () => {
                                        formik.resetForm();
                                        setClearPermissions(!clearPermissions);
                                      }
                                }
                                type="submit"
                              />
                              <MuiButton
                                className="get-btn"
                                label={isEditable ? "Update" : "create"}
                                onClick={handleFormSubmit}
                                type="submit"
                              />
                            </div>
                          </div>
                        </TabPanel>

                        <TabPanel value="2">
                          <div className="row text-center justify-content-end">
                            <div className="col-md-1">
                              <button
                                className="fliter-btn"
                                onClick={() => {
                                  SetView(!view);
                                }}
                              >
                                {view ? " View" : "Creation"}
                              </button>
                            </div>
                          </div>
                          {/* {view && (
                              <div className="row mt-3">
                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    placeholder="Corporate Name"
                                    label={"Corporate Name"}
                                    isRequired={true}
                                    isInvalid={
                                      formik.touched.spnr &&
                                      Boolean(formik.errors.spnr)
                                    }
                                    errorText={
                                      formik.touched.spnr && formik.errors.spnr
                                        ? formik.errors.spnr
                                        : ""
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={() =>
                                      formik.setFieldTouched("spnr", true)
                                    }
                                    value={formik.values.spnr}
                                  />
                                </div>

                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    placeholder="Email Id "
                                    label={"Email Id "}
                                    isRequired={true}
                                    isInvalid={
                                      formik.touched.hotelConfirmation &&
                                      Boolean(formik.errors.hotelConfirmation)
                                    }
                                    errorText={
                                      formik.touched.hotelConfirmation &&
                                      formik.errors.hotelConfirmation
                                        ? formik.errors.hotelConfirmation
                                        : ""
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={() =>
                                      formik.setFieldTouched(
                                        "hotelConfirmation",
                                        true
                                      )
                                    }
                                    value={formik.values.hotelConfirmation}
                                  />
                                </div>

                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    label={"Mobile No."}
                                    placeholder="Mobile No."
                                  />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    label={"Employee Code"}
                                    placeholder="Employee Code"
                                  />
                                </div>
                                <div className="col-md-1 mb-3">
                                  <MuiSearchSelect
                                    label="Title "
                                    placeholder={"Title "}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    label={"First Name"}
                                    placeholder="First Name"
                                  />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <MuiInput
                                    label={"Last Name"}
                                    placeholder="Last Name"
                                  />
                                </div>

                                <div className="col-md-3   mb-3">
                                  <MuiSearchSelect
                                    placeholder={"Gender "}
                                    label="Gender "
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-md-2 mb-3">
                                  <MuiDatePicker
                                    label="Date of Birth "
                                    value={null}
                                    onChange={function (date: string): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                  />
                                </div>

                                <div className="col-md-12">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Passport Details
                                    <span style={{ color: "red" }}>*</span>
                                  </FormLabel>

                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "80px",
                                    }}
                                  >
                                    <div className="row">
                                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                        <MuiInput
                                          label={"Passport No. "}
                                          placeholder="Passport No. "
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="Expiry date  "
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="Expiry date  "
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="Issued Country  "
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-7 mt-3">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Frequent Flyer
                                  </FormLabel>

                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "80px",
                                    }}
                                  >
                                    <div className="row">
                                      {rows.map((row, index) => (
                                        <React.Fragment key={index}>
                                          <div className="col-xl-5 col-lg-4 col-md-6 mb-3">
                                            <MuiSearchSelect
                                              placeholder={"Airline"}
                                              label="Airline"
                                              options={[]}
                                              onChange={(
                                                value: string,
                                                id: string,
                                                data: any
                                              ) => {
                                                // Implement actual handler here
                                              }}
                                              value={""}
                                            />
                                          </div>
                                          <div className="col-xl-5 col-lg-6 col-md-6 mb-3">
                                            <MuiInput
                                              label={"FFN Number"}
                                              placeholder="FFN Number"
                                            />
                                          </div>
                                          <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                                            <div className="d-flex justify-content-around mt-2">
                                              <button
                                                type="button"
                                                className="w-7 h-7 rounded-full bg-success bg-light-gradient text-light flex items-center justify-center text-sm border-none"
                                                onClick={handleAddRow}
                                              >
                                                <FaPlus />
                                              </button>
                                              {rows.length > 1 && (
                                                <button
                                                  type="button"
                                                  className="w-7 h-7 rounded-full bg-danger text-light flex items-center justify-center text-sm border-none ms-2"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleRemoveRow(index);
                                                  }}
                                                >
                                                  <FaMinus />
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-5 mt-3">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    SSR Perferance
                                  </FormLabel>

                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "80px",
                                    }}
                                  >
                                    <div className="row">
                                      <div className="col-xl-6 col-lg-4 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder={"Meal"}
                                          label="Meal"
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                      <div className="col-xl-6 col-lg-4 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder={"Seat"}
                                          label="Seat"
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="user-button w-full">
                                  <MuiButton
                                    className="clear-btn"
                                    label="Clear"
                                    onClick={() => formik.resetForm()}
                                    type="submit"
                                  />
                                  <MuiButton
                                    className="get-btn"
                                    label="Create"
                                    onClick={() => {}}
                                    type="submit"
                                  />
                                </div>
                              </div>
                            )} */}
                        </TabPanel>
                      </div>
                    </div>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CorporateManagement;
